import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import type { RoleScope } from '../../api/models/user.model';
import { EDIT_PERMISSION_LEVELS } from '../../constants/role';
import type { DataGridActionContext } from './DataGridToolbar/DataGridToolbarActionsComponent';

const hasSelectedOneOrMoreAssets = (selectedRows: any[]) => selectedRows.length > 0;

const hasRoleScope = (ctx: DataGridActionContext, roleScope: RoleScope) =>
	Boolean(ctx.role?.roleScopes.includes(roleScope));

const hasEditPermission = (ctx: DataGridActionContext) =>
	Boolean(ctx.role && EDIT_PERMISSION_LEVELS.includes(ctx.role.permissionLevel));

// Action object type for dynamic 'more' actions
export type DataGridMoreAction = {
	key: string;
	label: string;
	icon: React.ReactNode;
	onClick: (context: DataGridActionContext) => void;
	show: (context: DataGridActionContext) => boolean;
	modalComponent?: React.ReactNode;
	disabled?: boolean;
	tooltip?: string;
	dataTestId?: string;
};

export type DataGridMoreActionKeys =
	| 'exportTemplate'
	| 'uploadFile'
	| 'uploadLeasedFile'
	| 'editNonLeasedUserDefinedFields'
	| 'deleteNonLeasedAssets'
	| 'editLeasedUserDefinedFields';

export const DataGridMoreActions: Record<DataGridMoreActionKeys, DataGridMoreAction> = {
	exportTemplate: {
		key: 'exportTemplate',
		dataTestId: 'export-nla-template-button',
		label: 'Download Non-Leased Asset Import Template',
		icon: <FileDownloadOutlinedIcon fontSize="small" />,
		onClick: (ctx) => ctx.handleDownloadTemplateClick(),
		show: (_ctx) => true,
	},
	uploadFile: {
		key: 'uploadFile',
		label: 'Upload File',
		icon: <UploadFileIcon fontSize="small" />,
		onClick: (ctx) => ctx.openUploadModal(),
		show: (ctx) => hasEditPermission(ctx),
		// modalComponent: <UploadModal ... /> // to be rendered by parent
	},
	uploadLeasedFile: {
		key: 'uploadLeasedFile',
		label: 'Upload File',
		icon: <UploadFileIcon fontSize="small" />,
		onClick: (ctx) => ctx.openUploadLeasedAssetModal(),
		show: (ctx) => hasEditPermission(ctx),
	},
	editNonLeasedUserDefinedFields: {
		key: 'editUDF',
		label: 'Edit',
		icon: <ModeEditIcon fontSize="small" />,
		onClick: (ctx) => ctx.openEditNonLeasedUDFModal(),
		show: (ctx) =>
			hasRoleScope(ctx, 'CIRCADIA_UDF_EDIT_ACCESS') && hasSelectedOneOrMoreAssets(ctx.selectedRows),
	},
	deleteNonLeasedAssets: {
		key: 'deleteNLAs',
		label: 'Delete Assets',
		icon: <DeleteIcon fontSize="small" />,
		onClick: (ctx) => ctx.openDeleteConfirmationModal(),
		show: (ctx) => hasEditPermission(ctx) && hasSelectedOneOrMoreAssets(ctx.selectedRows),
	},
	editLeasedUserDefinedFields: {
		key: 'editUDF',
		label: 'Edit',
		icon: <ModeEditIcon fontSize="small" />,
		onClick: (ctx) => ctx.openEditLeasedUDFModal(),
		show: (ctx) =>
			hasRoleScope(ctx, 'CIRCADIA_UDF_EDIT_ACCESS') && hasSelectedOneOrMoreAssets(ctx.selectedRows),
	},
};
